const projectList = [
  {
    id: 0,
    name: "Sia Store",
    description:
      "User-friendly interface that provides seamless navigation and an intuitive shopping experience.",
    image: require("./images/sia.png"),
    website: "https://siaecomstore.netlify.app/",
    github: "https://github.com/bhoomihz/sia_store",
    tools: ["MERN Stack", "Postman API"],
    inView: false,
  },
  {
    id: 1,
    name: "Banking System",
    description:
      "Banking system where you can add, transfer, withdraw and view funds.",
    image: require("./images/bank.png"),
    github: "https://github.com/bhoomihz/BankingSystem",
    tools: ["EJS", "MongoDB", "Node.js", "Express.js"],
    inView: false,
  },
  {
    id: 2,
    name: "BlogSquad",
    description:
      "A medium where you can explore, create and give feedbacks on blogs",
    image: require("./images/blog.png"),
    github: "https://github.com/bhoomihz/MPR_BlogWebsite",
    tools: ["HTML", "CSS", "Node.js", "Express.js"],
    inView: false,
  },
  {
    id: 3,
    name: "WeatherInfo",
    description:
      "A website that allows users to search for any country and retrieve real-time weather related various information",
    image: require("./images/weather.png"),
    website: "https://weatherlatestupdates.netlify.app/",
    github: "https://github.com/bhoomihz/weather",
    tools: ["React-Hooks", "HTML", "CSS", "OpenWeather API"],
    inView: false,
  },

  {
    id: 4,
    name: "NotesKeeper",
    description: "A place where you can create, edit, delete notes",
    image: require("./images/notes.png"),
    website: "https://khoj-piedpiper.herokuapp.com/",
    github: "https://github.com/bhoomihz/notes-keeper",
    tools: ["HTML", "CSS", "Javascript"],
    inView: false,
  },
  {
    id: 5,
    name: "SpeechRecognition",
    description: "Speech to Text Converter",
    image: require("./images/speech.png"),
    website: "https://speechrecogn.netlify.app/",
    github: "https://github.com/bhoomihz/speech_recog",
    tools: ["React-dependencies", "CSS", "HTML"],
    inView: false,
  },
];

export default projectList;
